import InitialState from "./InitialState";
import * as types from "../actions/ActionTypes";

export default function dateReducer(state = InitialState.today, action) {
  switch (action.type) {
    case types.LOAD_TODAY_INFORMATION_SUCCESS:
      return action.today;
    default:
      return state;
  }
}
